import { CalendarEventKey } from 'mini-calendar-event-types';

/**
 * Creats a calendar event key.
 * @param timestamp - timestamp.
 * @param itemId - itemId.
 * @returns calendar event key.
 */
export default function createCalendarEventKey(
    timestamp: number,
    itemId: string
): CalendarEventKey {
    return {
        timestamp: timestamp,
        itemId: itemId,
    };
}
